module.exports = __webpack_public_path__ + "static/img/dkwps2-5.d6e4fa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-5.png
// module id = 670
// module chunks = 0